/**
 * 专利镖局 PDF订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>PDF订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.zlmc" style="width:120px" placeholder="输入专利名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.mobile" style="width:120px" placeholder="输入联系方式"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.zlbh" style="width:120px" placeholder="输入专利号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.status" style="width:140px" placeholder="请选择">
          <el-option v-for="type in status" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.zfsj" style="width:140px" placeholder="请选择">
          <el-option v-for="type in zfsj" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <!-- 支付时间 -->
      <el-form-item>
        <el-date-picker v-model="formInline.start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择支付开始时间" :picker-options="pickerOptions"> </el-date-picker>
         <!-- <el-date-picker v-model="formInline.start_time" align="right" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" :picker-options="pickerOptions"></el-date-picker> -->
      </el-form-item>

      <el-form-item>
        <el-date-picker v-model="formInline.end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择支付结束时间" :picker-options="pickerOptions"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportCheck" title="将导出所有勾选的数据">导出</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportAll" title="将导出所有满足条件的数据">导出全部</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="50">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column align="center" prop="zlmc" label="专利名称" width="160" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="zlbh" label="专利号" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="wx_name" label="微信昵称" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="mobile" label="联系方式" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="zlwyid" label="授权号" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="total_fee" label="支付金额" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="status" label="订单状态" :formatter="statusFormat" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="add_time" label="下单时间" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="pay_time" label="支付时间" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="email" label="邮箱" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleInfo(scope.$index, scope.row)">详情</el-button>
          <el-button size="mini" @click="handleInfo(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="delMonitor(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 详情界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="专利名称">
              <el-input size="small" v-model="infoForm.zlmc" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="专利号">
              <el-input size="small" v-model="infoForm.zlbh" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="授权号">
            <el-input size="small" v-model="infoForm.zlwyid" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="下单时间">
            <el-input size="small" v-model="infoForm.add_time" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="支付时间">
            <el-input size="small" v-model="infoForm.pay_time" auto-complete="off" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="微信昵称">
              <el-input size="small" v-model="infoForm.wx_name" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="联系方式">
              <el-input size="small" v-model="infoForm.mobile" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="订单状态">
            <el-input size="small" v-model="infoForm.status" auto-complete="off" disabled></el-input>
            </el-form-item>       
            <el-form-item label="支付金额">
            <el-input size="small" v-model="infoForm.total_fee" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="邮箱">
            <el-input size="small" v-model="infoForm.email" :formatter="txcsTypeFormat" auto-complete="off" disabled></el-input>
            </el-form-item>   
          </el-col>
        </el-row>
        <!-- <el-form-item label="备注">
          <el-input size="small" v-model="infoForm.remark" auto-complete="off" placeholder="请输入微信证书路径" disabled></el-input>
        </el-form-item> -->
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { wechatOrderPdf, wechatUrl } from '../../api/wechatMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '监控详情',
      multipleSelection: [],
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },
      status: [
        { key: '全部', value: 0 },
        { key: '未支付', value: 1 },
        { key: '已支付', value: 2 }
      ],
      zfsj: [
        { key: '全部', value: 0 },
        { key: '近一月', value: 1 },
        { key: '近半年', value: 2 },
        { key: '近一年', value: 3 },
      ],
      infoForm: {
        id: '',
        mobile: '',
        wx_name: '',
        zlbh: '',
        zlmc: '',
        zlwyid: '',
        email: '',
        add_time: '',
        pay_time: '',
        token: localStorage.getItem('logintoken')
      },
       formInline: {
        page: 1,
        ps: 10,
        start_time: '',
        end_time: '',
        zlmc: '',
        mobile: '',
        zfsj: 0,
        status: 0,
        zlbh: '',
        // token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      wechatOrderPdf(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
                type: 'info',
                message: res.msg
              })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //导出excel
    exportCheck() {
      //判断是否有勾选的数据，没有提示
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.id)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
      //添加提示框，确定后再导出，防止乱点，减轻服务器压力
      this.$confirm('确定导出勾选的记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        
        const idStr = JSON.stringify(idsArr)
        console.log(idStr)
        // console.log(data)
        window.location.href = wechatUrl + "/admin/patent/exportOrderPdfExcel?ids=" + idStr
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    exportAll() {
      this.$confirm('确定导出所有满足条件的记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
       .then(() => {
          window.location.href = wechatUrl + "/admin/patent/exportOrderPdfAllExcel?zlmc="+this.formInline.zlmc+"&mobile="+this.formInline.mobile+"&zlbh="+this.formInline.zlbh+"&status="
      +this.formInline.status+"&zfsj="+this.formInline.zfsj+"&start_time="+this.formInline.start_time+"&end_time="+this.formInline.end_time;
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示详情界面
    handleInfo: function(index, row) {
      console.log(row)
      this.editFormVisible = true
      this.infoForm = row
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          ConfigSave(this.infoForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('支付配置信息保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除监控记录
    delMonitor(index, row) {
        this.$message({
          type: 'info',
          message: '暂不支持!'
        })
        return false;
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
    // 根据不同值显示不同内容
    txcsTypeFormat(row,column){
        if(row.txcs > 0){
          return '已发送'
        }else{
          return '未发送'
        }
    },
    statusFormat(row,column){
      if(row.status == 2){
          return '已支付'
      }else{
          return '未支付'
      }
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/wechat/Orderpdf.vue